import { v4 } from "uuid";

const key = "gift.postal.uuid";

export const getUuid = () => {
  const uuid = window.localStorage.getItem(key);
  if (uuid) return uuid;

  const newUuid = v4();
  window.localStorage.setItem(key, newUuid);
  return newUuid;
};
